import { Dropdown } from 'primereact/dropdown'
import { Dispatch, FC, SetStateAction } from 'react'
import IconButton from '../buttons/IconButton'
import { DeleteIcon, PlusIcon } from '../Icons'
import { BasicNameValue } from '../../types/types'

type CustomStepDropDownProps = {
  step: BasicNameValue
  index: number
  readOnly?: boolean
  additionalMacroSteps: BasicNameValue[]
  setSteps: Dispatch<SetStateAction<BasicNameValue[]>>
  displayAdd?: boolean // Optional prop to control the display of the add button
}

const CustomStepDropDown: FC<CustomStepDropDownProps> = ({
  step,
  index,
  additionalMacroSteps,
  setSteps,
  displayAdd = false,
  readOnly = false
}) => {
  return (
    <div className="grid grid-cols-9 pb-2 gap-4">
      <Dropdown
        value={additionalMacroSteps.find(opt => opt.value === step.value) || null}
        pt={{
          root: {
            className:
              'min-w-full bg-transparent dark:border-neutral-70 dark:bg-transparent col-span-8'
          },
          input: {
            className: 'py-2'
          }
        }}
        disabled={readOnly}
        options={additionalMacroSteps}
        title={step.name}
        optionValue="value"
        useOptionAsValue
        onChange={e => {
          const prevValue = step
          const newValue = e.value
          setSteps(prev => {
            if (!prev) return [newValue]
            const newSteps = [...prev]
            const customIndex = newSteps.findIndex(step => step.name === prevValue.name)
            if (customIndex !== -1) {
              newSteps[customIndex] = newValue
            } else {
              newSteps.push(newValue)
            }
            return newSteps
          })
        }}
        placeholder="Select a custom macro step"
        className="min-w-full"
        optionLabel="name"
        emptyMessage="&nbsp;&nbsp;No Custom Macros found"
        filter
        filterBy="name"
        data-pr-tooltip="Select a custom macro step to add to the workflow"
        appendTo={'self'}
        panelClassName="min-w-full"
      />
      {/* Buttons for adding/removing custom steps */}
      {!readOnly && (
        <div className="flex items-center space-x-2 col-span-1">
          <IconButton
            title="Remove Custom Step"
            severity="danger"
            onClick={e => {
              setSteps(prev => {
                const customStepIndex = prev.findIndex(
                  s => s.name === step.name && s.value === step.value
                )
                if (customStepIndex !== -1) {
                  const newSteps = [...prev]
                  newSteps.splice(customStepIndex, 1)
                  return newSteps
                }
                return prev
              })
            }}
            icon={<DeleteIcon className="fill-white w-4 h-4" />}
          />
          {displayAdd && (
            <IconButton
              title="Add Custom Step"
              severity="info"
              onClick={() => {
                setSteps(prev => [...prev, new BasicNameValue({ name: '', value: '' })])
              }}
              icon={<PlusIcon className="fill-white w-5 h-5" />}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default CustomStepDropDown
